import { Link, usePage } from '@inertiajs/react'
import { FileQuestion, ShieldAlert } from 'lucide-react'
import { t } from '@/shared/lib/i18n'
import { rootPath } from '@/shared/lib/routes'
import { Button } from '@/shared/ui/button'

type ErrorStatus = 403 | 404

interface ErrorsShowProps {
  status?: number
  [key: string]: unknown
}

const ErrorsShow = () => {
  const { status } = usePage<ErrorsShowProps>().props
  const kind: ErrorStatus = status === 403 ? 403 : 404
  const isForbidden = kind === 403
  const Icon = isForbidden ? ShieldAlert : FileQuestion

  return (
    <div
      className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-4 px-4 py-10 text-center"
      data-testid={`error-page-${kind}`}
    >
      <div className="flex size-16 items-center justify-center rounded-full border-2 border-primary/30 text-primary">
        <Icon className="size-8" strokeWidth={1.75} aria-hidden="true" />
      </div>

      <p className="text-sm font-semibold text-muted-foreground">{kind}</p>

      <h1 className="text-2xl font-semibold tracking-tight">
        {isForbidden ? t('errors.forbidden.heading') : t('errors.notFound.heading')}
      </h1>

      <p className="max-w-md text-sm text-muted-foreground">
        {isForbidden ? t('errors.forbidden.description') : t('errors.notFound.description')}
      </p>

      <Button asChild>
        <Link href={rootPath()}>{t('errors.backToHome')}</Link>
      </Button>
    </div>
  )
}

export default ErrorsShow
